import { COLORS } from '../../Styles/Colors';
import { VendingAlertSeverity } from '../../Types/vending';

export const formatAlertDate = (value: string | null | undefined) => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const severityMeta = (severity: VendingAlertSeverity) => {
  switch (severity) {
    case 'critical':
      return { label: 'Critical', color: COLORS.red, bg: `${COLORS.red}12` };
    case 'high':
      return { label: 'High', color: COLORS.orange, bg: `${COLORS.orange}18` };
    case 'warning':
      return { label: 'Warning', color: COLORS.orange, bg: `${COLORS.orange}18` };
    default:
      return { label: 'Info', color: COLORS.teal, bg: `${COLORS.teal}14` };
  }
};

export const statusMeta = (status: string) => {
  const value = (status || '').toLowerCase();
  if (value === 'open') return { color: COLORS.teal, bg: `${COLORS.teal}14` };
  if (value === 'acknowledged') return { color: COLORS.orange, bg: `${COLORS.orange}18` };
  if (value === 'resolved') return { color: COLORS.success, bg: `${COLORS.success}18` };
  return { color: COLORS.lightGray, bg: `${COLORS.lightGray}18` };
};

export const vendingTableHeadCellSx = {
  py: 1.25,
  px: 2,
  fontWeight: 700,
  fontSize: '0.6875rem',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.05em',
  color: COLORS.lightGray,
  backgroundColor: '#f8f9fa',
  borderBottom: `1px solid ${COLORS.lightGray}35`,
  whiteSpace: 'nowrap' as const,
};

export const vendingTableBodyCellSx = {
  py: 1.75,
  px: 2,
  borderBottom: `1px solid ${COLORS.lightGray}30`,
  verticalAlign: 'middle' as const,
};
